module.exports = __webpack_public_path__ + "static/img/advantage5.ca120fb6.png";